<template>
<div>
    <el-upload :action="$root.uploadUrl"
               :show-file-list="false"
               :before-upload="beforeAvatarUpload"
               :on-progress="fileListHandleProgress"
               :on-success="fileListHandleSuccess"
               :on-error="fileListHandleError"
               :multiple="noMany ? false : true">
        <el-button v-if="isShowIcon == 1" size="small" type="primary"
                   :loading="fileListLoading"
                   :disabled="fileListDisabled">
            {{(fileListLoading)?'上传中...':'点击上传'}}
        </el-button>
        <el-button v-else size="small" type="primary"
                   :loading="fileListLoading"
                   :disabled="fileListDisabled">
            <i class="el-icon-upload"></i>
            {{(fileListLoading)?'上传中...':'上传'}}
        </el-button>
    </el-upload>
    <div class="file-list" v-if="!isShowList">
        <div v-for="(file,index) in fileList" :key="index" class="file-item clearfix">
            <div class="file-name">
                <!--<img src="../../assets/images/register/icon07.png" alt="" style="vertical-align: middle;">-->
                <span @click="fileListHandleDownload(file)" title="点击下载" style="text-decoration: underline;cursor: pointer;"><i class="el-icon-document"></i>{{file.attachName}}</span>
            </div>
            <div class="file-button">
                <el-button type="primary" v-show="canEdit && !noMany" size="small" @click="fileListHandleRemove(index)">删除</el-button>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/babel">
    import Vue from 'vue'
    export default Vue.component('page-upload', {
        data () {
            return {
                fileList: [],
                fileType: this.attachmentType,
                fileListLoading: false,
                fileListDisabled: false,//上传按钮是否禁用
                canEdit: this.editFlag,//是否可下载
                limit: this.limitType,//限制大小
                isShowIcon: this.isIconTable,//是否显示带图标按钮，及把上传文件列表按照table表格来显示；2,代表显示，1，代表不显示图标，普通上传。
                isShowList: this.notViewList || '',//传值true 代表不显示文件列表，自定义展现列表，不传代表用默认的列表
                noMany: this.notMany || '',//true,不支持上传多个文件，false，支持上传多个文件
                disAble: this.disable || '',//禁用
            }
        },
        props: ['attachmentType','files','editFlag','limitType','isIconTable','notViewList','notMany','disable'],
//        limitType,表示上传文件的大小限制类型 1：代表普通附件，限制50M，2: 代表招标附件，限制300M；
        created(){
            if(this.disAble){
                this.fileListDisabled = true;
            }
        },
        methods: {
            beforeAvatarUpload(file) {
                const isLt50M = file.size / 1024 / 1024 < 50;
                const isLt500M = file.size / 1024 / 1024 < 500;
                if(this.limit == 1){
                    if (!isLt50M) {
                        this.$message.error('上传附件大小不能超过 50MB!');
                        return isLt50M;
                    }
                } else if(this.limit == 2){
                    if (!isLt500M) {
                        this.$message.error('上传附件大小不能超过 500MB!');
                        return isLt500M;
                    }
                }
            },
            fileListHandleProgress(){
                this.fileListLoading = true;
                this.fileListDisabled = true;
            },
            fileListHandleSuccess(response){
                let that = this;
                that.fileListLoading = false;
                that.fileListDisabled = false;
                if(response.code == 1){
                    for(let i=0; i< response.data.length; i++){
                        let obj = response.data[i];
                        obj['attachmentType'] = that.fileType;
                        if(that.noMany){
                           that.fileList = [];
                            that.fileList.push(obj);
                        } else {
                            that.fileList.push(obj);
                        }
                    }
//                    console.log('上传',that.fileList)
                    that.$emit('finishUpload',{fileList: that.fileList});
                    that.$message.success('上传成功');
                }else{
                    this.$message.error('上传失败');
                }
            },
            fileListHandleError(response){
                let that = this;
//                console.log('上传失败',response);
                that.$message.error('上传失败');
                that.fileListLoading = false;
                that.fileListDisabled = false;
            },
            fileListHandleRemove(index){
//                console.log(index)
                let that = this;
                that.$confirm('确定删除该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.fileList.splice(index,1);
                            that.$emit('finishUpload',{fileList: that.fileList});
                        }
                    }
                });
            },
            fileListHandleDownload(file){
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.downloadFile({
                                attachName: file.attachName,
                                attachPath: file.attachPath
                            })
                        }
                    }
                });
            }
        },
        mounted(){
            this.fileList = this.files;
        }
    })

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/_var.scss';
    .file-list{}
    .file-list .file-item{
        overflow: hidden;
    }
    .file-list .file-name{
        float: left;
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .file-list .file-button{
        float: left;
        margin-left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/MyUpload.vue